module.exports = __webpack_public_path__ + "media/images/slides/long_leg-943d977800dbc05da54cec49e4867b25.jpg";